import * as React from 'react';
import { MiddlewareSync } from "@sa/rep-common";
import { ComponentProcessingState } from "@sa/rep-react";
import { ComponentTreemap } from "../components/ComponentTreeMap";
import { ContextReport1 } from "../Context";
import { REPORT_ID, REPORT_APE_ID } from '../constants';

export const aquariumCropValueComponentMiddleware: MiddlewareSync<ComponentProcessingState> = (input, next) => {
  const { identification, componentContext } = input;
  if (REPORT_APE_ID === identification.reportId || REPORT_ID === identification.reportId) {
    if (identification.componentId === "chart-aquarium-crop-value") {
      input.component = <ComponentTreemap context={componentContext as ContextReport1}></ComponentTreemap>;
    }
  }
  return next(input);
};
